import { StatCard } from '@/common/dashboard/StatCard';
import { Spacer } from '@/common/layout/SpacerLayout';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { TreeUtils } from '@/common/utils/TreeUtils';
import { useEffect, useState } from 'react';

export const DirSaleGrowthCards = ({ formValues, totalProdIds }) => {
  const rsrc = useRsrc();

  const [data, setData] = useState();

  useEffect(() => {
    if (!formValues?.invPeriodId) {
      return;
    }

    const prodFilter = TreeUtils.smallestIdFilter(formValues.prodIds, totalProdIds);

    const reqParam = {
      invPeriodId: formValues.invPeriodId,
      prodIds: prodFilter.ids,
      prodIdsNot: prodFilter.not,
    };

    rsrc.data('sc', 'DIR_SALE_GROWTH_CARDS_DATA_PLUGIN', reqParam).then((res) => {
      setData(res);
    });
  }, [formValues?.invPeriodId, formValues?.prodIds, totalProdIds]);

  return (
    <Spacer vertical>
      <StatCard
        title="YoY Brand Change"
        val={data?.largestBrandAmtDelta}
        isAmt
        pctChange={data?.largestBrandPctDelta === 0 ? null : data?.largestBrandPctDelta}
        vsLabel={data?.priorPeriodCode}
        label={data?.brandCode}
      />
      <StatCard
        title="YoY Contract Change"
        val={data?.largestCtrtAmtDelta}
        isAmt
        pctChange={data?.largestCtrtPctDelta === 0 ? null : data?.largestCtrtPctDelta}
        vsLabel={data?.priorPeriodCode}
        label={data?.ctrtName}
      />
    </Spacer>
  );
};
